import { CzechMobilePhone } from "@/components/MobilePhoneFormatted/CzechMobilePhone";
import { ForeignMobilePhone } from "@/components/MobilePhoneFormatted/ForeignMobilePhone";
import { EnumerationsContext } from "@/contexts/EnumerationsContext";
import { phone } from "@/utils/formatters";
import { useContext } from "react";

interface MobilePhoneFormattedProps {
  mobilePhone: string;
  mobileCountryCode?: string;
}

export const MobilePhoneFormatted = ({ mobilePhone, mobileCountryCode }: MobilePhoneFormattedProps) => {
  const { countries } = useContext(EnumerationsContext);

  const isCz = !mobileCountryCode || mobileCountryCode === "CZ";

  return isCz ? (
    <CzechMobilePhone mobilePhone={mobilePhone} />
  ) : (
    <ForeignMobilePhone mobilePhone={phone(mobilePhone, mobileCountryCode, countries) ?? ""} />
  );
};
